import collectionTabTemplate from './collectionTabTemplate';

export default collectionTabTemplate(['collection'], ({ collections }) => collections.create);
